import { render, staticRenderFns } from "./template_approval_management.vue?vue&type=template&id=62ae3324&scoped=true&"
import script from "./template_approval_management.vue?vue&type=script&lang=js&"
export * from "./template_approval_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae3324",
  null
  
)

export default component.exports